import React, {Component} from 'react';
import {Button, Cascader, Col, DatePicker, Form, Input, message, Row, Select} from 'antd';

import {connect} from 'react-redux';
import {queryAccountList} from '@api/core/user';
import {queryOrgList} from '@api/core/org';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountList: [],
      options: [],
      orgUuid: '',
    };
  }

  componentDidMount() {
    this.loadOrg();
    this.loadAccount();
  }

  submit = e => {
    e.preventDefault();
    const data = this.props.form.getFieldsValue();
    this.props.search(data);
  };

  onChange = value => {
    this.setState({
      orgUuid: value.length - 1,
    });
    const data = this.props.form.getFieldsValue();
    data.orgUuid = this.state.orgUuid;
    this.loadAccount(value[value.length - 1]);
    this.props.form.setFieldsValue({ userUuid: '' });
  };

  /**
   *获取组织列表
   */
  loadOrg = () => {
    const params = {};
    params.uuid = '19F83BB0108B4255AA38D457E3FFF223';
    queryOrgList(params).then(res => {
      if (res.statusCode === 200) {
        const options = [
          {
            label: '全部',
            value: '-1',
          },
        ];
        res.data.map(item => {
          const optionItem = {};
          optionItem.label = item.name;
          optionItem.value = item.uuid;
          optionItem.isLeaf = false;
          options.push(optionItem);
          return options;
        });
        this.setState({
          options,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   *获取用户列表
   */
  loadAccount = orgUuid => {
    const uuid = orgUuid || '';
    queryAccountList({ orgUuid: uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          accountList: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  loadData = selectedOptions => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    const params = {};
    params.uuid = targetOption.value;
    queryOrgList(params).then(res => {
      if (res.statusCode === 200) {
        const options = [];
        if (res.data.length < 1) {
          targetOption.isLeaf = true;
        } else {
          res.data.map(item => {
            const optionItem = {};
            optionItem.label = item.name;
            optionItem.value = item.uuid;
            optionItem.isLeaf = false;
            options.push(optionItem);
            return options;
          });
          targetOption.children = options;
        }

        targetOption.loading = false;

        this.setState({
          options: [...options],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  reset = e => {
    e.preventDefault();
    this.props.form.setFieldsValue({
      condition: undefined,
      cdate: undefined,
      orgUuid: undefined,
      userUuid: undefined,
    });
    const data = this.props.form.getFieldsValue();
    this.props.search(data);
  };

  /**
   * 部门显示最后一级
   */
  showLable = label => {
    const text = label[label.length - 1];
    return text;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { accountList } = this.state;
    return (
      <Form className="search-form" layout="horizontal" onSubmit={this.submit}>
        <Row justify="space-between" type="flex">
          <Col span={5}>
            <FormItem>
              {getFieldDecorator('condition')(<Input placeholder="订单编号/合同编号" />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              {getFieldDecorator('cdate')(
                <DatePicker placeholder="订单创建时间" style={{ width: '100%' }} />,
              )}
            </FormItem>
          </Col>
          <Col span={7}>
            <FormItem label="所属人" {...formItemLayout}>
              {getFieldDecorator('orgUuid')(
                <Cascader
                  options={this.state.options}
                  loadData={this.loadData}
                  onChange={this.onChange}
                  placeholder="部门"
                  changeOnSelect
                  displayRender={this.showLable}
                />,
              )}
            </FormItem>
          </Col>
          <Col span={2}>
            <FormItem style={{ width: '100%' }}>
              {getFieldDecorator('userUuid', {
                rules: [{ message: '姓名不能为空！' }],
              })(
                <Select
                  placeholder="姓名"
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option key="-1">全部</Option>
                  {accountList.map(item => {
                    return <Option key={item.uuid}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              <Row type="flex" justify="end">
                <Button type="primary" htmlType="submit" style={{ marginRight: '10px' }}>
                  搜索
                </Button>
                <Button onClick={this.reset} style={{ marginRight: '10px' }}>
                  重置
                </Button>
              </Row>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default connect(state => state)(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/xianxing/order/FormSearch.js